import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, ActivityIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { MobileNav } from './MobileNav';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const navItems = [{
    id: 'overview',
    label: 'Overview',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'metrics',
    label: 'Metrics',
    icon: BarChart2Icon,
    section: 'metrics',
    href: '#metrics'
  }, {
    id: 'timeline',
    label: 'Timeline',
    icon: ActivityIcon,
    section: 'timeline',
    href: '#timeline'
  }, {
    id: 'proof',
    label: 'Proof',
    icon: ShieldCheckIcon,
    section: 'proof',
    href: '#proof'
  }, {
    id: 'audience',
    label: 'Audience',
    icon: UsersIcon,
    section: 'audience',
    href: '#audience'
  }];
  const handleExport = () => {
    window.print();
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-gray-100 sticky top-0 z-50 print:static print:border-b-0" data-id="element-361">
      <div className="container mx-auto px-4 md:px-6" data-id="element-362">
        <div className="flex items-center justify-between h-16 print:h-auto print:py-4" data-id="element-363">
          <div className="flex items-center" data-id="element-364">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caJJCtS3envvP8mN4NRUHS/Brandpulse_logo.png" alt="BrandPulse" className="h-7 w-auto" data-id="element-365" />
          </div>

          <nav className="hidden md:flex items-center space-x-1 print:hidden" data-id="element-366">
            {navItems.map(item => {
            const Icon = item.icon;
            const isActive = activeItem === item.section;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${isActive ? 'bg-[#1E90FF]/10 text-[#1E90FF]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-367">
                  <Icon className={`h-4 w-4 mr-2 ${isActive ? 'text-[#1E90FF]' : 'text-gray-500'}`} data-id="element-368" />
                  {item.label}
                </a>;
          })}
          </nav>

          <div className="flex items-center space-x-3 print:hidden" data-id="element-369">
            <button onClick={handleExport} className="hidden md:flex items-center space-x-2 bg-white border border-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 hover:border-gray-300 transition-colors shadow-sm" data-id="element-370">
              <FileDownIcon className="h-4 w-4" data-id="element-371" />
              <span data-id="element-372">Export PDF</span>
            </button>

            <a href="https://create.brandpulse-analytics.com/" target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center bg-[#1E90FF] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#1E90FF]/90 transition-all shadow-sm shadow-blue-200 whitespace-nowrap" data-id="element-373">
              Create new
            </a>

            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-374">
              <MenuIcon className="h-6 w-6 text-gray-600" data-id="element-375" />
            </button>
          </div>
        </div>
      </div>

      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-376" />
    </header>;
};